import { Location } from 'react-router-dom';

// Hjälpfunktioner för att bära med sig vart användaren var på väg genom inloggningen.
// Destinationen kan inte ligga i React Routers state, det överlever inte hoppet ut till
// identity-servern, utan skickas i OIDC-anropets eget state och kommer tillbaka på user.state.

export const buildReturnUrl = (location: Location): string => `${location.pathname}${location.search}${location.hash}`;

// Bara lokala vägar får användas som returadress. Utan kontrollen går adressen att byta mot
// en annan webbplats i inloggningslänken, och då har vi en öppen omdirigering att nätfiska med.
// Dubbel snedstreck och snedstreck plus bakstreck är protokollrelativa adresser, alltså externa.
export const isSafeReturnUrl = (value: unknown): value is string =>
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\');

// tenant och type styr kundens logotyp på inloggningssidan och vilka acr_values som skickas
// med till identity-servern. De ligger i länken användaren fick, så de måste följa med vidare
// när en skyddad sida skickar en utloggad besökare till inloggningen.
export const buildLoginSearch = (location: Location): string => {
  const current = new URLSearchParams(location.search);
  const next = new URLSearchParams();

  const tenant = current.get('tenant');
  const type = current.get('type');

  if (tenant) {
    next.set('tenant', tenant);
  }

  if (type) {
    next.set('type', type);
  }

  const search = next.toString();

  return search ? `?${search}` : '';
};
